import React from 'react';
import {Container,Row,Col,Button,Form} from 'react-bootstrap';
import './index.scss';
import  { useEffect, useState } from 'react';

import logo from '../../assets/img/logo-bg.png';

var track = 0;

export default function Header(){

    var menu = ()=>{
      let  el = document.getElementsByClassName("expand-side");
      if(track==0){
        document.getElementsByClassName("side-panel")[0].classList.remove("p-hide");
        track++;
      }
      else{

        if(el.length>0){
            let buttons = document.getElementsByClassName("menu-btn-text");
            let icons = document.getElementsByClassName("menu-icons");
            for(let i=0; i<buttons.length;i++){
               
                buttons[i].style.display="none";
                icons[i].classList.remove("float-left");
            } 

            document.getElementsByClassName("side-panel")[0].classList.remove("expand-side");
           
            document.getElementsByClassName("side-panel")[0].classList.add("collapse-side");
          }
          else{
            let buttons = document.getElementsByClassName("menu-btn-text");
            let icons = document.getElementsByClassName("menu-icons");
            for(let i=0; i<buttons.length;i++){
                buttons[i].style.display="inline";
                icons[i].classList.add("float-left");
            } 
            
            document.getElementsByClassName("side-panel")[0].classList.add("expand-side");
            document.getElementsByClassName("side-panel")[0].classList.remove("collapse-side");
          }
      }


    
    }
  

    return (

        <>
        <Container fluid className='mt-0  mb-0 mr-0 ml-0 p-0 position-sticky header-container top-0 '>

          <Row className='m-0 header-box w-100'>
              <Col className='col-2'><div className='menu-bars hover' onClick={menu}><i className='fa fa-bars'></i></div></Col>
              <Col  className='col'><div className='float-left mt-1'><h2>EA Trade</h2> </div> <img className="float-left logo-header" src={logo} /></Col>
              <Col className='col-sm-5'><div className='text-secondary p-1 '><h4 className='taxi-rank'>Admin Dashboard</h4></div></Col>
          </Row>
        </Container>
        </>

    );
}